import { CultureInfo } from '../culture-info.model';
import { CultureInfoQu } from './qu';

/**
 * @ignore
 */
export const CultureInfoQuEC: CultureInfo = {
  name: 'qu-EC',
  displayName: 'Runasimi (Ecuador)',
  iso3LanguageCode: 'que',
  iso2LanguageCode: 'qu',
  ietfLanguageTag: 'qu-EC',
  parent: CultureInfoQu
};
